"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var appender_base_1 = require("./appender.base");
var enums_1 = require("../enums");
var consts_1 = require("../consts");
/**
 * Writes structured {@link ILogMessage} to the remote storage.
 */
var RemoteAppender = /** @class */ (function (_super) {
    __extends(RemoteAppender, _super);
    function RemoteAppender() {
        var _this = _super.call(this) || this;
        _this.type = enums_1.AppenderType.Remote;
        return _this;
    }
    RemoteAppender.prototype.getAppenderName = function () { return 'RemoteAppender'; };
    RemoteAppender.prototype.action = function (message, config) {
        message.extendedParameters = this.stringifyValues(message.extendedParameters);
        message = __assign(__assign({}, message), __assign({ extendedParameters: undefined }, message.extendedParameters));
        if (config.requiredFields && config.requiredFields.length) {
            this.validateMessage(message, config);
        }
        if (!config.url) {
            var errorMessage = "Please specify URL for " + this.getAppenderName();
            console.error(errorMessage);
            return;
        }
        var requestUrl = this.createRequestUrl(config.url, this.getStringMessage(message));
        this.sendRequest(requestUrl);
    };
    RemoteAppender.prototype.getStringMessage = function (message) {
        message.url = encodeURIComponent(message.url);
        if (message.exception) {
            var exceptionString = JSON.stringify(message.exception, Object.getOwnPropertyNames(message.exception));
            var messageClone = __assign(__assign({}, message), { exception: exceptionString });
            return JSON.stringify(messageClone);
        }
        return JSON.stringify(message);
    };
    RemoteAppender.prototype.sendRequest = function (requestUrl) {
        var request = new XMLHttpRequest();
        try {
            request.open('GET', requestUrl, true);
            request.send();
        }
        catch (e) {
            console.error("Error: Failed to send a log request (Timber)", e);
        }
    };
    RemoteAppender.prototype.createRequestUrl = function (url, queryParams) {
        var urlPrefix = url + "?data=";
        var requestUrl = urlPrefix + queryParams;
        if (requestUrl.length > consts_1.MaxCloudfrontRequestSize) {
            requestUrl = requestUrl.slice(0, consts_1.MaxCloudfrontRequestSize - consts_1.ErrorMessage.maximumRequestSizeExceeded.length - consts_1.ErrorMessage.separator.length);
            return requestUrl + consts_1.ErrorMessage.separator + consts_1.ErrorMessage.maximumRequestSizeExceeded;
        }
        return requestUrl;
    };
    RemoteAppender.prototype.validateMessage = function (message, config) {
        var absentFields = [];
        Object.getOwnPropertyNames(message).forEach(function (key) {
            var value = message[key];
            if (!value && config.requiredFields.indexOf(key) !== -1) {
                absentFields.push(key);
            }
        });
        if (absentFields.length) {
            var errorMessage = "Following properties are required for " + this.getAppenderName() + ": " + absentFields.join(', ') + ". Please provide it";
            throw new Error(errorMessage);
        }
    };
    RemoteAppender.prototype.stringifyValues = function (extendedParameters) {
        if (!extendedParameters) {
            return undefined;
        }
        var result = {};
        for (var key in extendedParameters) {
            if (typeof extendedParameters[key] === 'string') {
                result[key] = extendedParameters[key];
            }
            else {
                result[key] = JSON.stringify(extendedParameters[key]);
            }
        }
        return result;
    };
    return RemoteAppender;
}(appender_base_1.Appender));
exports.RemoteAppender = RemoteAppender;
//# sourceMappingURL=appender.remote.js.map